import { Component, Input, OnInit } from '@angular/core';

export interface IChartModel {
    time: string;
    value: number;
    color?: string;
    height?: string;
}

@Component({
    selector: 'app-bar-chart',
    templateUrl: './bar-chart.component.html',
    styleUrls: ['./bar-chart.component.scss']
})
export class BarChartComponent implements OnInit {
    @Input() results: Array<IChartModel>;
    @Input() barWidth = 30;
    @Input() barGap = 5;
    @Input() showValue = false;
    @Input() showLabel = false;
    
    maxHeight = 0;
    data: Array<IChartModel> = [
        // for testing
        // { value: 0, time: '01/01/2023' },
        // { value: 0, time: '01/02/2023' },
        // { value: 1, time: '01/03/2023' },
        // { value: 2, time: '01/04/2023' },
    ];

    connectionValues = [50, 100, 75];
    connectionColors = ['#ff0000', '#00ff00', '#ffff00'];

    constructor() {
    }

    ngOnInit(): void {
        if (this.results) {
            this.data = this.results;
        }
        this.initChart();
    }

    initChart() {
        this.data.forEach(row => {
            row.color = this.connectionColors[row.value];
            row.height = `${this.connectionValues[row.value]}%`; 
            // this.maxHeight = Math.max(this.maxHeight, row.value);
        });
    }
}
